import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  padding-bottom: 1.5rem;

  display: flex;
  flex-direction: column;
  overflow: hidden;

  background-color: ${({ theme }) => theme.zds.colors.neutral1000};
  border-radius: ${({ theme }) => theme.zds.border.radius100};
`
